module.exports = __webpack_public_path__ + "images/19743-EXT1-Cam01-f05ab88d7b03894ca0d730b5c5f406d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_3/19743-EXT1-Cam01.jpg
// module id = 779
// module chunks = 0